module.exports = __webpack_public_path__ + "static/fonts/FiraSans-Italic.a8ff3a2.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/FiraSans/FiraSans-Italic.ttf
// module id = 1159
// module chunks = 5